import { CrewAccordion } from 'components/elements/crewAccordion/crewAccordion'
import { FC, memo, useCallback } from 'react'
import { DirectChannelEntryDialog } from 'features/chat/components/directChannelEntryDialog/directChannelEntryDialog'
import { DirectMessageUserList } from './components/directMessageUserList/directMessageUserList'
import { useTranslation } from '@crew/modules/i18n'
import { useShowApiErrors } from 'hooks/useShowApiErrors'
import { useModal } from 'components/layouts/modal/useModal'
import { useDirectMessageUserPanel } from './useDirectMessageUserPanel'
import { EntityType } from '@crew/enums/domain'
import Add from '~icons/material-symbols/add'
import { useCrewNavigate } from 'hooks/useCrewNavigate'
import { getDefaultTabValue } from '@crew/utils/dist/enum'
import { DirectMessageTabs } from 'enums/app'

export const DirectMessageUserPanel: FC = memo(() => {
  const {
    insertDirectChannel,
    insertFavorite,
    isLoadingInsertProjectForDirectChannelMutation,
  } = useDirectMessageUserPanel()

  const { t } = useTranslation()
  const { navigate } = useCrewNavigate()

  const [isDialogOpen, openDialog, closeDialog] = useModal()

  const [showApiErrors] = useShowApiErrors()

  // ダイレクトチャンネルユーザ登録ダイアログで選択したユーザを登録
  const handelUserSelected = useCallback(
    async (targetUserId: string) => {
      try {
        // Create direct channel as a project
        const result = await insertDirectChannel(targetUserId)
        if (!result.directChannel?.id) return

        // Create favorite for login user
        await insertFavorite(EntityType.Project, result.directChannel?.id)

        // 選択したユーザーとのダイレクトチャンネル画面へ遷移
        navigate(
          `/direct-channels/${result.directChannel.id}/${getDefaultTabValue(
            DirectMessageTabs
          )}`
        )
      } catch (err) {
        showApiErrors(err)
        return
      }

      closeDialog()
    },
    [closeDialog, insertDirectChannel, insertFavorite, navigate, showApiErrors]
  )

  // ダイレクトチャンネル追加ダイアログを開くアイコン
  const renderToolIcon = useCallback(() => {
    return <Add width={20} height={20} onClick={openDialog} />
  }, [openDialog])

  return (
    <>
      <CrewAccordion
        id="direct-message-user-panel"
        title={t('label.directMessage')}
        content={<DirectMessageUserList />}
        renderToolIcon={renderToolIcon}
      />
      <DirectChannelEntryDialog
        title={t('label.addUser') + ' - ' + t('label.directMessage')}
        isOpen={isDialogOpen}
        isLoading={isLoadingInsertProjectForDirectChannelMutation}
        onClose={closeDialog}
        onUserSelected={handelUserSelected}
      />
    </>
  )
})
